// extracted by mini-css-extract-plugin
export var container = "_mi-0";
export var dotAnimation = "_mi-2";
export var dotsLoading = "_mi-1";